export default __webpack_public_path__ + "a1635d0e393e69dfc672c25d640da3bc.svg";